"use strict";

var __assign = function () {
    return (__assign = Object.assign || function (t) {
      for (var e, n = 1, r = arguments.length; n < r; n++) for (var o in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
      return t;
    }).apply(this, arguments);
  },
  mappers_1 = (Object.defineProperty(exports, "__esModule", {
    value: !0
  }), exports.getItemsInSlide = exports.canUseDOM = exports.getTransformMatrix = exports.getTranslateXProperty = exports.getTouchmoveTranslatePosition = exports.getTranslate3dProperty = exports.getRenderStageItemStyles = exports.getRenderStageStyles = exports.getTransitionProperty = exports.getRenderWrapperStyles = exports.animate = exports.shouldHandleResizeEvent = exports.getElementFirstChild = exports.getElementCursor = exports.getAutoheightProperty = exports.getElementDimensions = exports.getItemWidth = exports.createDefaultTransformationSet = exports.createAutowidthTransformationSet = exports.isElement = exports.createClones = exports.getItemsOffset = exports.getItemsCount = exports.getSlides = void 0, require("./mappers")),
  math_1 = require("./math"),
  getSlides = function (t) {
    var e = t.children,
      t = t.items;
    return e ? e.length ? e : [e] : void 0 === t ? [] : t;
  },
  getItemsCount = (exports.getSlides = getSlides, function (t) {
    return (0, exports.getSlides)(t).length;
  }),
  getItemsOffset = (exports.getItemsCount = getItemsCount, function (t) {
    var e = t.infinite,
      n = t.paddingRight,
      t = t.paddingLeft;
    return e && (t || n) ? 1 : 0;
  }),
  createClones = (exports.getItemsOffset = getItemsOffset, function (t) {
    var e,
      n,
      r,
      o,
      i = (0, exports.getSlides)(t);
    return t.infinite ? (e = (0, exports.getItemsCount)(t), o = (0, exports.getItemsOffset)(t), t = (0, exports.getItemsInSlide)(e, t), r = Math.min(t, e) + o, n = i.slice(0, r), r = i.slice(-r), o && t === e && (o = i[0], t = i.slice(-1)[0], r.unshift(t), n.push(o)), r.concat(i, n)) : i;
  }),
  isElement = (exports.createClones = createClones, function (t) {
    try {
      return t instanceof Element || t instanceof HTMLDocument;
    } catch (t) {
      return !1;
    }
  }),
  createAutowidthTransformationSet = (exports.isElement = isElement, function (t, i, e) {
    void 0 === i && (i = 0), void 0 === e && (e = !1);
    var s = 0,
      a = !0,
      n = [];
    return (0, exports.isElement)(t) && (n = Array.from((null == t ? void 0 : t.children) || []).reduce(function (t, e, n) {
      var r = 0,
        n = n - 1,
        o = t[n],
        e = getElementDimensions(null == e ? void 0 : e.firstChild).width,
        e = void 0 === e ? 0 : e;
      return a = (s += e) <= i, o && (r = 0 == n ? o.width : o.width + o.position), t.push({
        position: r,
        width: e
      }), t;
    }, []), e || (n = a ? (0, mappers_1.mapPartialCoords)(n) : (t = s - i, (0, mappers_1.mapPositionCoords)(n, t)))), {
      coords: n,
      content: s,
      partial: a
    };
  }),
  createDefaultTransformationSet = (exports.createAutowidthTransformationSet = createAutowidthTransformationSet, function (t, o, e, n) {
    void 0 === n && (n = !1);
    var i = 0,
      s = !0,
      r = [],
      a = (0, exports.getItemWidth)(o, e);
    return r = t.reduce(function (t, e, n) {
      var r = 0,
        n = t[n - 1];
      return s = (i += a) <= o, n && (r = a + n.position || 0), t.push({
        width: a,
        position: r
      }), t;
    }, []), {
      coords: r = n ? r : s ? (0, mappers_1.mapPartialCoords)(r) : (e = i - o, (0, mappers_1.mapPositionCoords)(r, e)),
      content: i,
      partial: s
    };
  }),
  getItemWidth = (exports.createDefaultTransformationSet = createDefaultTransformationSet, function (t, e) {
    return 0 < e ? t / e : t;
  });
function getElementDimensions(t) {
  return t && t.getBoundingClientRect ? {
    width: (t = t.getBoundingClientRect()).width,
    height: t.height
  } : {
    width: 0,
    height: 0
  };
}
exports.getItemWidth = getItemWidth, exports.getElementDimensions = getElementDimensions;
var getAutoheightProperty = function (t, e, n) {
    var e = (0, exports.getElementCursor)(e, n),
      n = (0, exports.getElementFirstChild)(t, e);
    if ((0, exports.isElement)(n)) return t = window.getComputedStyle(n), e = parseFloat(t.marginTop), t = parseFloat(t.marginBottom), Math.ceil(n.offsetHeight + e + t);
  },
  getElementCursor = (exports.getAutoheightProperty = getAutoheightProperty, function (t, e) {
    var n = e.activeIndex,
      e = e.itemsInSlide;
    return t.infinite ? n + e + (0, exports.getItemsOffset)(t) : n;
  }),
  getElementFirstChild = (exports.getElementCursor = getElementCursor, function (t, e) {
    t = t && t.children || [];
    return t[e] && t[e].firstChild || null;
  });
function shouldHandleResizeEvent(t, e, n) {
  return (e = void 0 === e ? {} : e).width !== (n = void 0 === n ? {} : n).width;
}
function animate(t, e) {
  var e = e || {},
    n = e.position,
    n = void 0 === n ? 0 : n,
    r = e.animationDuration,
    r = void 0 === r ? 0 : r,
    e = e.animationEasingFunction,
    e = void 0 === e ? "ease" : e;
  return t && (0, exports.isElement)(t) && (t.style.transition = "transform ".concat(r, "ms ").concat(e, " 0ms"), t.style.transform = "translate3d(".concat(n, "px, 0, 0)")), t;
}
exports.getElementFirstChild = getElementFirstChild, exports.shouldHandleResizeEvent = shouldHandleResizeEvent, exports.animate = animate;
var getRenderWrapperStyles = function (t, e, n) {
    var r = t || {},
      o = r.paddingLeft,
      i = r.paddingRight,
      s = r.autoHeight,
      r = r.animationDuration,
      s = s ? (0, exports.getAutoheightProperty)(n, t, e) : void 0;
    return {
      height: s,
      transition: s ? "height ".concat(r, "ms") : void 0,
      paddingLeft: "".concat(o, "px"),
      paddingRight: "".concat(i, "px")
    };
  },
  getTransitionProperty = (exports.getRenderWrapperStyles = getRenderWrapperStyles, function (t) {
    var t = t || {},
      e = t.animationDuration,
      t = t.animationEasingFunction,
      t = void 0 === t ? "ease" : t;
    return "transform ".concat(void 0 === e ? 0 : e, "ms ").concat(t, " 0ms");
  }),
  getRenderStageStyles = (exports.getTransitionProperty = getTransitionProperty, function (t, e) {
    t = (t || {}).translate3d, t = "translate3d(".concat(-(void 0 === t ? 0 : t), "px, 0, 0)");
    return __assign(__assign({}, e), {
      transform: t
    });
  }),
  getRenderStageItemStyles = (exports.getRenderStageStyles = getRenderStageStyles, function (t, e) {
    var n = e.transformationSet,
      r = e.fadeoutAnimationIndex,
      o = e.fadeoutAnimationPosition,
      i = e.fadeoutAnimationProcessing,
      e = e.animationDuration,
      n = (n[t] || {}).width;
    return i && r === t ? {
      transform: "translateX(".concat(o, "px)"),
      animationDuration: "".concat(e, "ms"),
      width: "".concat(n, "px")
    } : {
      width: n
    };
  }),
  getTranslate3dProperty = (exports.getRenderStageItemStyles = getRenderStageItemStyles, function (t, e) {
    var n = t,
      r = e.infinite,
      o = e.itemsOffset,
      i = e.itemsInSlide,
      e = e.transformationSet;
    return ((void 0 === e ? [] : e)[n = r ? t + (0, math_1.getShiftIndex)(void 0 === i ? 0 : i, void 0 === o ? 0 : o) : n] || {}).position || 0;
  }),
  getTouchmoveTranslatePosition = (exports.getTranslate3dProperty = getTranslate3dProperty, function (t, e) {
    return -(e - Math.floor(t));
  });
function getTranslateXProperty(t) {
  t = getTransformMatrix(t), t = t && t[4] || "";
  return Number(t);
}
function getTransformMatrix(t) {
  return t && (0, exports.isElement)(t) && window.getComputedStyle(t).transform.match(/(-?[0-9.]+)/g) || [];
}
exports.getTouchmoveTranslatePosition = getTouchmoveTranslatePosition, exports.getTranslateXProperty = getTranslateXProperty, exports.getTransformMatrix = getTransformMatrix;
var canUseDOM = function () {
    var t;
    try {
      return Boolean(null == (t = null === window || void 0 === window ? void 0 : window.document) ? void 0 : t.createElement);
    } catch (t) {
      return !1;
    }
  },
  getItemsInSlide = (exports.canUseDOM = canUseDOM, function (n, t) {
    var r,
      o = 1,
      i = t.responsive,
      e = t.autoWidth,
      s = t.infinite,
      t = t.innerWidth;
    return void 0 !== e && e ? void 0 !== s && s ? n : o : (i && (e = Object.keys(i)).length && (t || (0, exports.canUseDOM)()) && (r = void 0 === t ? window.innerWidth : t, e.forEach(function (t) {
      var e;
      Number(t) <= r && (e = (t = i[t]).items, t = t.itemsFit, o = "contain" === (void 0 === t ? "fill" : t) ? e : Math.min(e, n));
    })), o || 1);
  });
exports.getItemsInSlide = getItemsInSlide;